export enum LogLevel {
	INFO = 'ℹ️ Info message',
	WARNING = '⚠️ Warning message',
	ERROR = '🌋Error message',
}

export function LogMessage(location: string, message: any, level: LogLevel = LogLevel.ERROR) {
	//TODO: Set up logging;

	console.log(`${level} at ${location} - ${JSON.stringify(message)}`);
}

export async function logError(e: any, title?: string) {
	let message = '';
	if (e instanceof Error) {
		message = e.message;
		//Network failures from fetch only say "fetch failed", with the actual reason on the cause
		const cause = (e as Error & { cause?: { code?: string; message?: string } }).cause;
		if (cause && (cause.code || cause.message)) message += ` (${cause.code || cause.message})`;
	} else if (e instanceof Response) {
		message = `Status: ${e.status}, \n\n${await e.clone().text()}`;
	} else if (typeof e === 'string') {
		message = e;
	} else {
		message = JSON.stringify(e);
	}

	//Remove any quotes from the start and end of the string
	message = message.replace(/^"(.+(?="$))/, '$1').replace(/^\s*"(.*)"\s*$/, '$1');

	console.log(title ? `${title}: ` : '', message);
	return message;
}
